// src/components/StatusBanner.jsx
import React from "react";
import "../styles/StatusBanner.css";

const ICONS = {
  error: "⚠️",
  success: "✅",
  info: "ℹ️",
  warning: "⚠️",
};

export default function StatusBanner({
  type = "info", // "error" | "success" | "info" | "warning"
  title, // optional short heading
  message, // string OR React node
  onClose, // optional close handler
  className = "", // extra classes if needed
}) {
  if (!message) return null;

  return (
    <div
      className={`status-banner status-banner--${type} ${className}`}
      role={type === "error" ? "alert" : "status"}
      aria-live={type === "error" ? "assertive" : "polite"}
    >
      <div className="status-banner-icon">{ICONS[type] || ICONS.info}</div>

      <div className="status-banner-content">
        {title && <div className="status-banner-title">{title}</div>}
        <div className="status-banner-message">{message}</div>
      </div>

      {onClose && (
        <button
          type="button"
          className="status-banner-close"
          onClick={onClose}
          aria-label="Dismiss message"
        >
          ×
        </button>
      )}
    </div>
  );
}
